export const SESSIONS_NODE = 'sessions';
